import React from "react";
import {
  GelBoxLayout,
  GelContainerLite,
  GelHeading3,
} from "@tal-gel/components";
import brandLogo from "../assets/images/tal-logo.svg";
import { getGelTokens } from "@tal-gel/theming";
import heroImage from "../assets/images/background.jpg";

export interface HeaderProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = (props) => {
  const { global: { themeColorWhite, sizeBaseX15 } } = getGelTokens()

  return (
    <div>
      <GelContainerLite
        gutter="small"
        style={{ backgroundColor: themeColorWhite }}
      >
        <GelBoxLayout gap="large" distribution="end" marginLeft="medium">
          <div
            style={{
              float: "left",
              height: 60,
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              id="brand-logo"
              alt="logo"
              src={brandLogo}
              style={{ display: "block", margin: "auto", cursor: "pointer" }}
            />
          </div>
        </GelBoxLayout>

      </GelContainerLite>
      <div
        style={{
          alignItems: "stretch",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          textAlign: "center",
        }}
      >
        <div
          style={{
            backgroundImage: `url(${heroImage})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            height: `${sizeBaseX15 * 3}px`,
            alignItems: "center",
            textAlign: "center",
            display: "flex",
            WebkitBoxAlign: "center",
          }}
        >
          <GelHeading3 marginLeft="large" inverse="true">
            {props.title}
          </GelHeading3>
        </div>
      </div>
    </div>
  );
};

export default Header;
